export default {
  parents: {
    margin: '0 -22px 20px',
    padding: '22px 22px 30px',
    borderBottom: '1px solid #eee'
  },
  documents: {
    margin: '0 -22px',
    padding: '22px 22px 30px'
  }
}
